import { render } from "./confirmPage.vue?vue&type=template&id=644b0da5&scoped=true"
import script from "./confirmPage.vue?vue&type=script&lang=js"
export * from "./confirmPage.vue?vue&type=script&lang=js"

import "./confirmPage.vue?vue&type=style&index=0&id=644b0da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644b0da5"]])

export default __exports__